import {
  Form,
  Field,
  defineRule,
  configure,
} from 'vee-validate';
import {
  required, email, min as minRule, max, numeric
} from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import ValidatedInput from 'components/ValidatedInput.vue';
import ValidatedSelect from 'components/ValidatedSelect.vue';
import ValidatedMultiselect from 'components/ValidatedMultiselect.vue';
import CountrySelect from 'components/forms/CountrySelect.vue';
import { translate } from 'utils/i18n';

export default {
  install(app) {
    app.component('v-form', Form);
    app.component('v-field', Field);
    app.component('validated-input', ValidatedInput);
    app.component('validated-select', ValidatedSelect);
    app.component('validated-multiselect', ValidatedMultiselect);
    app.component('country-select', CountrySelect);

    defineRule('required', required);
    defineRule('email', email);
    defineRule('min', minRule);
    defineRule('max', max);
    defineRule('numeric', numeric);

    defineRule('passwordconfirmation', (value, [target]) => {
      if (!value || !value.length) {
        return true;
      }

      if (value === target) {
        return true;
      }

      return translate('validation.password.confirmationMismatch');
    });

    defineRule('password', (value, [min]) => {
      if (!min) {
        min = 8;
      }

      if (!value || typeof value !== 'string') {
        return false;
      }

      if (value.length < 8) {
        return false;
      }

      if (!value.match(/\d/)) {
        return false;
      }

      if (!value.match(/[a-z|A-Z]/)) {
        return false;
      }

      return true;
    });

    configure({
      generateMessage: localize({
        en,
      }),
    });
  }
};
